import { Component, Input, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from 'app/shared/dialog';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership, Activity, APIService, ModelNotificationStagingAllNotificationsByOwnerCompositeKeyConditionInput, ModelSortDirection, NotificationStaging } from '../../API.service.custom';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatButton } from '@angular/material/button';
import { FormatDatePipe } from '../../../services/format-date.pipe';
import { FormatUnderscorePipe } from '../../../services/format-underscore.pipe';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [NgxSkeletonLoaderModule, MatButton, FormatDatePipe, FormatUnderscorePipe]
})
export class NotificationsComponent implements OnInit {
  notifications : NotificationStaging[] = [];
  activAccountSubscription;
  activeAccount : AccountMembership = null;
  nextToken : string = undefined;
  limit = 50;
  isLoading = true;


  constructor(private dialog: DialogRef, private config: DialogConfig, private api: APIService, private dataService: DataShareService, private toastr: ToastrService) { }

  ngOnInit() {
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
          this.activeAccount = param;
          this.fetchNotifications()
      }
    });
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
        this.activAccountSubscription.unsubscribe();
  }

  fetchNotifications(){
    let d = new Date();
    var pd = new Date(new Date().setDate(d.getDate() - 30));
    let f = <ModelNotificationStagingAllNotificationsByOwnerCompositeKeyConditionInput>{}
    f.between = [{ownerId : this.activeAccount.userId, scheduledAt : pd.toISOString()}, {ownerId : this.activeAccount.userId, scheduledAt : d.toISOString()}]
    this.api.ListAllNotificationsByOwner(this.activeAccount.accountId, f, ModelSortDirection.DESC, undefined, this.limit, this.nextToken).then(event => {
      console.log('Notifications Fetched : ', event);
      this.isLoading = false;
      this.nextToken = event.nextToken;
      if (event && event.items){
        if(this.notifications && this.notifications.length > 0)
          this.notifications.push(...event.items);
        else
          this.notifications = event.items;
      }
    })
      .catch(e => {
        this.isLoading = false;
        console.log('Error Fetching Notifications', e);
        this.showErrorInToastr(e, 'Error Fetching Teams')
      });

  }

  loadMore(){
    this.fetchNotifications();
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

  closeSidebar(){
    this.dialog.close();
  }

  showFilter(){

  }

  showAction(){
    
  }

}
